import {useContext} from 'react';

import {DocumentExtractionBehaviourContext} from '../contexts/DocumentExtractionBehaviourContext';

export const useDocumentExtractionBehaviour = () => useContext(DocumentExtractionBehaviourContext);
